var _path, _path2, _path3, _g, _path4, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIsUploading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 144,
    viewBox: "0 0 244 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.107 54.2785L62.082 79.8809L76.2274 137.907C77.0122 141.127 80.2582 143.1 83.4777 142.316L176.844 119.555C180.064 118.77 182.037 115.524 181.253 112.305L167.107 54.2785Z",
    fill: "#E3E0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.108 87.667L113.13 112.324C113.863 115.362 117.579 116.555 119.938 114.494L140.825 96.347C143.374 94.1228 142.371 89.9184 139.062 89.1318L112.181 82.6218C109.143 81.8895 106.403 84.629 107.136 87.667H107.108Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.717 40.4816L58.6914 66.084L62.0625 79.9126L167.088 54.3102L163.717 40.4816Z",
    fill: "#E3E0FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9479 62.1465L60.6445 65.6351L72.9478 77.2871L87.2278 73.7984L74.9479 62.1465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.901 55.8184L86.6211 59.2837L98.901 70.9589L113.204 67.4703L100.901 55.8184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.835 43.1426L138.531 46.6312L150.834 58.3064L165.138 54.8178L152.835 43.1426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.885 49.4941L112.582 52.9595L124.885 64.6347L139.165 61.1461L126.885 49.4941Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.918 0.616996L51.7109 53.6348L58.6918 66.0389L152.898 13.0211L145.918 0.616996Z",
    fill: "#E3E0FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.268 57.8984L60.4531 65.1315L61.4532 48.2001L74.2681 40.9902L73.268 57.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5415 44.7968L83.7266 52.0067L84.7499 35.0985L97.5648 27.8887L96.5415 44.7968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.131 18.5859L130.316 25.7957L131.34 8.8875L144.155 1.67773L143.131 18.5859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85 31.6758L107.012 38.9089L108.035 21.9774L120.85 14.7676L119.85 31.6758Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.148,
    cy: 84.416,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.086,
    cy: 56.5059,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0742,
    cy: 106.525,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.73438,
    cy: 126.689,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.438,
    cy: 62.1504,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.438,
    cy: 115.525,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.73438,
    cy: 81.791,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.6914,
    cy: 128.783,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.086,
    cy: 99.0176,
    r: 4.5,
    fill: "#E3E0FB"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1914,
    cy: 86.291,
    r: 4.5,
    fill: "#E3E0FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIsUploading);
export default __webpack_public_path__ + "static/media/videoIsUploading.a16f606a8a6638b15b3f0b8046ed5601.svg";
export { ForwardRef as ReactComponent };